import { isDefined } from "@omni/utils/helper.utils";
import { createContext, ReactNode, use } from "react";

type MappedContextValue = {
    index: number;
};

type MappedContextProviderProps = {
    index?: number;
    children: ReactNode;
};

type Props<T> = {
    array: Array<T>;
    children: ReactNode;
};

const MappedContext = createContext<MappedContextValue | undefined>(undefined);

export const MappedContextProvider = ({
    index,
    children
}: MappedContextProviderProps) => {
    if (!isDefined(index)) return null;

    return <MappedContext value={{ index: index }}>{children}</MappedContext>;
};

export const Mapped = <T,>({ array, children }: Props<T>) => {
    return array.map((_, index) => (
        <MappedContextProvider
            key={index}
            index={index}
        >
            {children}
        </MappedContextProvider>
    ));
};

export const useMapped = (fallback?: number) => {
    const context = use<MappedContextValue | undefined>(MappedContext);

    const index = context?.index ?? fallback;

    if (!isDefined(index)) {
        throw new Error();
    }

    return { index: index };
};
